const BILLING_METHOD = {
  CORPORATE: "Corporate",
  INDIVIDUAL: "Individual",
};

const BILLING_TIMELINE = {
  ANNUALLY: "Annually",
  QUARTERLY: "Quarterly",
  MONTHLY: "Monthly",
};

const SOLUTION_OPTIONS = {
  MYDOCS_WITH_SIGNATURE: "myDocs with signature",
  MYDOCS_WITHOUT_SIGNATURE: "myDocs without signature",
};

const ONBOARDING_PROPERTY_STATUS = {
  IN_DRAFT: "In Draft",
  PROPERTY_CREATED: "Property Created",
  PROPERTY_DEACTVATED: "Property Deactive",
  PENDING_APPROVAL: "Pending Approval",
  APPROVED: "Approved",
  PENDING_ACTIVATION: "Pending Activation",
};

const ONBOARDING_CUSTOMER_STATUS = {
  IN_DRAFT: "In Draft",
  CUSTOMER_CREATED: "Customer Created",
  CUSTOMER_DEACTVATED: "Customer Deactive",
  PENDING: "Pending",
};

const ONBOARDING_USER_STATUS = {
  PENDING: "Pending",
  ACTIVE: "Active",
  DEACTVATED: "Deactivated",
  IN_DRAFT: "In Draft",
};

const ONBOARDING_CORPORATE_CONTACT_STATUS = {
  ...ONBOARDING_USER_STATUS,
};

const ONBOARDING_PROPERTY_CONTACT_STATUS = {
  ...ONBOARDING_CORPORATE_CONTACT_STATUS,
};

const RECORD_OPERATIONS = {
  ADD: "add",
  EDIT: "edit",
  DELETE: "delete",
  APPROVE: "approve",
};

const ONBOARDING_USER_TYPE = {
  CORPORATE_CONTACT: "Corporate Contact",
  PROPERTY_CONTACT: "Property Contact",
  MDO_SALES_TEAM: "Sales Team",
};


const PROPERTY_APPROVAL_OPPERATIONS = {
  VALIDATE: "VALIDATE",
  APPROVE: "APPROVE",
  REMOVE: "REMOVE",
};


export {
  BILLING_METHOD,
  BILLING_TIMELINE,
  SOLUTION_OPTIONS,
  ONBOARDING_CUSTOMER_STATUS,
  ONBOARDING_CORPORATE_CONTACT_STATUS,
  RECORD_OPERATIONS,
  ONBOARDING_USER_TYPE,
  ONBOARDING_PROPERTY_CONTACT_STATUS,
  ONBOARDING_PROPERTY_STATUS,
  PROPERTY_APPROVAL_OPPERATIONS,
};
